import { contentCardsSlice } from './content-cards/content-cards.slice';
import { offersSlice } from './offers/offers.slice';
import { rewardsSlice } from './rewards/rewards.slice';
import { userSlice } from './user/user.slice';
import { loyaltyWalmartSlice } from './walmart/walmart.slice';

type LoyaltyActions = typeof offersSlice.actions &
  typeof userSlice.actions &
  typeof rewardsSlice.actions &
  typeof loyaltyWalmartSlice.actions &
  typeof contentCardsSlice.actions;

const { setLoyaltyWalmartUI, setLoyaltyWalmartUILoading } = loyaltyWalmartSlice.actions;
const {
  setContentCards,
  setWebContentCards,
  refreshUnreadContentCards,
} = contentCardsSlice.actions;
// Exporting all actions from slices in one file mimics exported variables from a context and encourages more explicit naming
// As an added benefit, we are able to see which actions come from which slice in a central location
const { setUser, setLoyaltyLoading } = userSlice.actions;

const {
  applyOffer,
  removeAppliedOfferByCartEntry,
  resetAppliedOffers,
  resetAppliedDiscountOffers,
  resetOfferFeedbackMap,
  setAppliedOffers,
  setCmsOffers,
  setIncentivesIds,
  setGuestEngineOfferListItems,
  setOffersFeedbackMap,
  setOffersLoading,
  setOfferRedemptionAvailableAfter,
  setAppPersonalizedOffers,
  setSelectedOffer,
  setEngineOfferListItems,
  setShouldRefetchOffers,
  unshiftAppPersonalizedOffer,
  removeAppliedOffer,
} = offersSlice.actions;

const {
  applyReward,
  createAvailableLoyaltyRewardsMap,
  rehydrateAppliedReward,
  removeAppliedReward,
  removeAppliedRewards,
  resetLoyaltyRewardsState,
  setAvailableLoyaltyRewardsMap,
  setIsPricingRewardApplication,
  setShouldRefetchRewards,
  setStagedCartPoints,
  unApplyReward,
  setRewardsFeedbackMap,
} = rewardsSlice.actions;

export const loyaltyActions: LoyaltyActions = {
  // Offers slice actions
  applyOffer,
  removeAppliedOfferByCartEntry,
  resetAppliedOffers,
  resetAppliedDiscountOffers,
  resetOfferFeedbackMap,
  setAppliedOffers,
  setCmsOffers,
  setIncentivesIds,
  setGuestEngineOfferListItems,
  setOffersFeedbackMap,
  setOffersLoading,
  setOfferRedemptionAvailableAfter,
  setAppPersonalizedOffers,
  setSelectedOffer,
  setEngineOfferListItems,
  setShouldRefetchOffers,
  unshiftAppPersonalizedOffer,
  removeAppliedOffer,
  // Rewards slice actions
  applyReward,
  createAvailableLoyaltyRewardsMap,
  rehydrateAppliedReward,
  removeAppliedReward,
  removeAppliedRewards,
  resetLoyaltyRewardsState,
  setAvailableLoyaltyRewardsMap,
  setIsPricingRewardApplication,
  setShouldRefetchRewards,
  setStagedCartPoints,
  unApplyReward,
  setRewardsFeedbackMap,
  // User slice actions
  setUser,
  setLoyaltyLoading,
  // Walmart slice actions
  setLoyaltyWalmartUI,
  setLoyaltyWalmartUILoading,
  // Content Card actions
  setContentCards,
  setWebContentCards,
  refreshUnreadContentCards,
};
